import { server_connection } from 'config';
import store from 'store';

export const REBUILD_GRADEBOOK = '[UTILS APP] REBUILD GRADEBOOK';

export function rebuildGradebook() {
    return (dispatch, getState) => {
        fetch(server_connection + '/gradebook/rebuild_gradebook')
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: REBUILD_GRADEBOOK,
                    payload: data,
                });
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/utils/store/actions/utils.actions.js